import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { InputLabel } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    fontSize: '0.9rem',
    fontWeight: 400,
    color: 'var(--color-fontColors-black)',
    marginTop: '-24px',
    marginBottom: '10px',
    display: 'flex',
    position: 'initial',
    transform: 'none',
  },
}));

const FormAdvancedLabel = ({ className = '', children }) => {
  const classes = useStyles();

  return (
    <InputLabel className={`FormAdvancedLabel ${classes.root} ${className}`}>
      {children}
    </InputLabel>
  );
};

export default FormAdvancedLabel;
